<ng-container *mweIsFeatureEnabled="featureToggleName()">
  @if (isAlertVisible()) {
    @if (data().alert.type === 'danger') {
      <mwe-inline-notification
        [iconClassOverwrite]="data().alert.icon"
        [messageKey]="data().alert.text"
        [titleKey]="data().alert.title"
        type="danger"
      />
    } @else {
      <mwe-infobox
        [iconClassOverwrite]="data().alert.icon"
        [messageKey]="data().alert.text"
        [titleKey]="data().alert.title"
        [type]="data().alert.type"
      />
    }
  }
</ng-container>
